module.exports = __webpack_public_path__ + "img/bank.5961d2b7.png";